"use client";
import {
  ripple_default
} from "./chunk-QHRCZSEO.mjs";
import {
  useRipple
} from "./chunk-6VC6TS2O.mjs";
export {
  ripple_default as Ripple,
  useRipple
};
